$(document).ready(function(){
  // 最新記事から6件取得
  var url = 'https://hataraku.vivivit.com/wp-json/posts?type=works&type=portfolio&type=creators&type=special&type=interview&type=column&filter[post_per_page]=6&filter[order]=DESC&filter[orderby]=date';
  $.ajax({
    type: 'GET',
    url: url,
    dataType: 'json'
  }).done(function(json){
    var w = window.innerWidth ? window.innerWidth: $(window).width();
    if ( w > 768 ) {
      for(var i=0; i < 5; i++){
        $("div.media-container").append(
          '<div class="m-image-card">' +
            '<a href="' + json[i].link + '">' +
              '<div class="m-image-card-inner">' +
                '<div class="image-container image-liquid" style="background-image:url(' + json[i].featured_image.source + ');"></div>' +
                  '<div class="m-image-card-genre">' + json[i].type.toUpperCase() + '</div>' +
                  '<div class="m-image-card-overlay" style="display:block"><div class="m-overlay-inner">' +
                    '<p class="m-image-card-title">' +
                      '<a target="_blank" href="' + json[i].link + '">' + json[i].title + '</a>' +
                    '</p>' +
                    '<div class="m-credit-container">' +
                      '<p class="m-image-card-genre-o">' + json[i].type.toUpperCase() + '</p>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</a>' +
          '</div>'
        );
      }
    } else {
      for (var s=0; s < 5; s++) {
        $("div.media-container").append(
          '<article class="m-image-card-s">' +
            '<div class="m-image-card">' +
              '<a href="' + json[s].link + '">' +
                '<div class="m-image-card-inner">' +
                  '<div class="image-container image-liquid" style="background-image:url(' + json[s].featured_image.source + ');"></div>' +
                    '<div class="m-image-card-genre">' + json[s].type.toUpperCase() + '</div>' +
                  '</div>' +
                '</div>' +
              '</a>' +
            '</div>' +
            '<div class="m-image-card-overlay" style="display:block"><div class="m-overlay-inner">' +
              '<p class="m-image-card-title">' +
                '<a target="_blank" href="' + json[s].link + '">' + json[s].title + '</a>' +
              '</p>' +
              '<div class="m-credit-container">' +
                '<p class="m-image-card-genre-o">' + json[s].type.toUpperCase() + '</p>' +
              '</div>' +
            '</div>' +
          '</article>'
        );
      }
    }

  }).fail(function(json, textStatus){
    $('div.media-container').append('更新はありません。' + textStatus);
  });

});
